import { ShoesState } from 'src/types'
import { generateMesh } from './meshMatrial'
import { darkenColor } from 'src/util/color'
import { getUpperMaterial } from 'src/features/atoms/shoes/logic'

const baseDesign = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.lineType.value === 'doubleLine' ? state.line2.color : state.line.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(223, 388) // 左端
  ctx.quadraticCurveTo(307, 379, 307, 379)
  ctx.quadraticCurveTo(301, 436, 310, 506)
  ctx.quadraticCurveTo(339, 508, 395, 499)
  ctx.quadraticCurveTo(456, 408, 454, 408)
  ctx.quadraticCurveTo(559, 445, 559, 445)
  ctx.quadraticCurveTo(632, 395, 632, 395)
  ctx.quadraticCurveTo(619, 296, 619, 294)
  ctx.quadraticCurveTo(581, 374, 581, 374)
  ctx.quadraticCurveTo(490, 346, 490, 346)
  ctx.quadraticCurveTo(544, 249, 544, 249)
  ctx.quadraticCurveTo(531, 245, 518, 263)
  ctx.quadraticCurveTo(462, 340, 462, 338)
  ctx.quadraticCurveTo(379, 315, 373, 317)
  ctx.quadraticCurveTo(338, 329, 338, 329)
  ctx.quadraticCurveTo(223, 388, 223, 388)
  //   ctx.quadraticCurveTo()
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  //   canvasResetter(ctx) // リセット
}

const mainDesign = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.line.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(242, 379) // 左端
  ctx.quadraticCurveTo(308, 373, 308, 373)
  ctx.quadraticCurveTo(306, 454, 315, 507)
  ctx.quadraticCurveTo(391, 499, 391, 499)
  ctx.quadraticCurveTo(418, 465, 448, 405)
  ctx.quadraticCurveTo(451, 398, 457, 403)
  ctx.quadraticCurveTo(556, 439, 556, 439)
  ctx.quadraticCurveTo(624, 392, 624, 392)
  ctx.quadraticCurveTo(617, 310, 617, 310) // 右上
  ctx.quadraticCurveTo(586, 372, 586, 372)
  ctx.quadraticCurveTo(583, 381, 576, 378)
  ctx.quadraticCurveTo(486, 350, 486, 350)
  ctx.quadraticCurveTo(479, 348, 484, 340)
  ctx.quadraticCurveTo(542, 248, 542, 248)
  ctx.quadraticCurveTo(528, 250, 523, 263)
  ctx.quadraticCurveTo(466, 340, 466, 340)
  ctx.quadraticCurveTo(465, 345, 458, 343)
  ctx.quadraticCurveTo(401, 328, 367, 323)
  ctx.quadraticCurveTo(338, 328, 338, 328)
  ctx.quadraticCurveTo(288, 361, 242, 379)
  //   ctx.quadraticCurveTo()
  //   ctx.quadraticCurveTo()

  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.lineWidth = 1.5
  const onStitchColor = darkenColor(state.line.color, 0.3)
  ctx.strokeStyle = onStitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  ctx.moveTo(257, 375) // 左
  ctx.quadraticCurveTo(284, 373, 313, 363)
  ctx.quadraticCurveTo(313, 438, 318, 504)

  ctx.moveTo(349, 360) // 中央
  ctx.quadraticCurveTo(349, 424, 364, 488)
  ctx.quadraticCurveTo(402, 443, 434, 386)
  ctx.quadraticCurveTo(399, 367, 349, 360)

  ctx.moveTo(251, 377) // 左
  ctx.quadraticCurveTo(305, 358, 335, 334)
  ctx.quadraticCurveTo(369, 326, 369, 326)
  ctx.quadraticCurveTo(469, 349, 469, 349)
  ctx.quadraticCurveTo(494, 305, 533, 252)
  ctx.quadraticCurveTo(476, 350, 476, 350)
  ctx.quadraticCurveTo(585, 384, 585, 384)
  ctx.quadraticCurveTo(615, 320, 615, 320)
  ctx.quadraticCurveTo(615, 354, 620, 387)
  ctx.quadraticCurveTo(591, 412, 553, 433)
  ctx.quadraticCurveTo(501, 408, 448, 396)
  ctx.quadraticCurveTo(417, 456, 388, 498)
  // ctx.quadraticCurveTo()

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#383838'

  //   canvasResetter(ctx) // リセット
}

const centerBaseDesign = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = state.lineType.value === 'doubleLine' ? state.line2.color : state.line.color
  ctx.lineWidth = 1.0
  ctx.beginPath()
  ctx.moveTo(355, 367) // 上
  ctx.quadraticCurveTo(354, 420, 367, 480) // 下
  ctx.quadraticCurveTo(400, 438, 426, 393)
  ctx.quadraticCurveTo(432, 387, 423, 383)
  ctx.quadraticCurveTo(361, 365, 361, 365)
  ctx.quadraticCurveTo(355, 363, 355, 367)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.fillStyle = state.mainUnit.color
  ctx.beginPath()
  ctx.moveTo(362, 372) // 上
  ctx.quadraticCurveTo(359, 418, 368, 469)
  ctx.quadraticCurveTo(424, 390, 424, 390)
  ctx.quadraticCurveTo(362, 372, 362, 372)
  //   ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.fill()
  //   ctx.quadraticCurveTo()
  ctx.closePath()

  const { isMesh } = getUpperMaterial(state)
  if (isMesh) {
    //  ATOMSマーク中央
    ctx.fillStyle = '#ccc'
    generateMesh(ctx, 2, 364, 380)
    generateMesh(ctx, 3, 364, 390)
    generateMesh(ctx, 4, 364, 400)
    generateMesh(ctx, 5, 364, 410)
    generateMesh(ctx, 7, 364, 420)
    generateMesh(ctx, 8, 364, 430)
    generateMesh(ctx, 9, 364, 440)
    generateMesh(ctx, 10, 364, 450)
    generateMesh(ctx, 8, 364, 460)
    generateMesh(ctx, 3, 364, 470)
  }

  //   canvasResetter(ctx) // リセット
}

export const atomsDesign = (ctx: CanvasRenderingContext2D | null, state: ShoesState): void => {
  if (!ctx) return
  baseDesign(ctx, state)
  mainDesign(ctx, state)
  centerBaseDesign(ctx, state)

  ctx.strokeStyle = 'white'
  ctx.lineWidth = 1.5
  ctx.beginPath()
  ctx.moveTo(243, 380)
  ctx.quadraticCurveTo(308, 374, 308, 374)
  ctx.quadraticCurveTo(306, 451, 315, 507)
  ctx.moveTo(391, 499)
  ctx.quadraticCurveTo(425, 455, 448, 405)
  ctx.quadraticCurveTo(450, 398, 458, 403)
  ctx.quadraticCurveTo(556, 440, 556, 440)
  ctx.quadraticCurveTo(624, 393, 624, 393)
  ctx.quadraticCurveTo(617, 310, 617, 309)
  ctx.quadraticCurveTo(586, 374, 586, 374)
  ctx.quadraticCurveTo(584, 382, 573, 377)
  ctx.quadraticCurveTo(486, 350, 486, 350)
  ctx.quadraticCurveTo(479, 346, 484, 339)
  ctx.quadraticCurveTo(541, 248, 541, 248)

  ctx.moveTo(370, 323)
  ctx.quadraticCurveTo(415, 331, 463, 345)
  ctx.quadraticCurveTo(529, 254, 529, 254)

  ctx.moveTo(243, 380)
  ctx.quadraticCurveTo(295, 355, 324, 336)

  ctx.moveTo(355, 372)
  ctx.quadraticCurveTo(357, 430, 367, 481)
  ctx.quadraticCurveTo(426, 396, 426, 396)
  ctx.quadraticCurveTo(433, 386, 422, 383)
  ctx.quadraticCurveTo(362, 366, 362, 366)
  ctx.quadraticCurveTo(352, 363, 355, 372)
  // ctx.quadraticCurveTo()
  ctx.stroke()
  ctx.closePath()
}

// ctx.beginPath()
// ctx.moveTo(0, 0)
// ctx.quadraticCurveTo(0, 0, 0, 0)
// ctx.closePath()
